import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IMeetingStatus } from "../meetingstatusModel";

export const getAllMeetingStatus = createAsyncThunk(
  "MeetingStatus/FindAllMeetingStatus",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MeetingStatus/FindAllMeetingStatus`,
        {
          meeting_status: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveMeetingStatus = createAsyncThunk(
  "MeetingStatus/FindAllActiveMeetingStatus",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/MeetingStatus/FindAllActiveMeetingStatus`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching MeetingStatus:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createMeetingStatus = createAsyncThunk(
  "MeetingStatus/InsertMeetingStatus",
  async (MeetingStatusData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MeetingStatus/InsertMeetingStatus`,
        MeetingStatusData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating MeetingStatus:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateMeetingStatus = createAsyncThunk(
  "MeetingStatus/UpdateMeetingStatus",
  async (MeetingStatusData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MeetingStatus/UpdateMeetingStatus`,
        MeetingStatusData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating MeetingStatus:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getMeetingStatusByID = createAsyncThunk(
  "MeetingStatus/FindByIDMeetingStatus",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MeetingStatus/FindByIDMeetingStatus`,
        { meeting_status_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        meeting_status: result.meeting_status,
        meeting_status_guid: result.meeting_status_guid,
        isactive: result.isactive === true ? 1 : 2,
      } as IMeetingStatus;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching MeetingStatus:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const MeetingStatusActiveInactive = createAsyncThunk(
  "MeetingStatus/ActiveInActiveMeetingStatus",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MeetingStatus/ActiveInActiveMeetingStatus`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive MeetingStatus:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteMeetingStatus = createAsyncThunk(
  "MeetingStatus/DeleteMeetingStatus",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MeetingStatus/DeleteMeetingStatus`,
        { meeting_status_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting statusofservice:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
